import { useEffect, useRef, useState } from "react"
import { api, toApiMessage } from "../../api/client"
import { showToast } from "../../components/ui"

const REMINDER_COOLDOWN_MS = 5_000

export function useTaskReminder(familyId: string) {
  const [pendingId, setPendingId] = useState<string | null>(null)
  const [coolingDown, setCoolingDown] = useState(false)
  const cooldownTimer = useRef<number | null>(null)

  useEffect(
    () => () => {
      if (cooldownTimer.current !== null) window.clearTimeout(cooldownTimer.current)
    },
    []
  )

  async function remind(occurrenceId: string) {
    if (pendingId || coolingDown) return
    setPendingId(occurrenceId)
    try {
      await api.post(`/families/${familyId}/tasks/occurrences/${occurrenceId}/remind`)
      showToast("Напоминание отправлено")
      setCoolingDown(true)
      cooldownTimer.current = window.setTimeout(() => {
        cooldownTimer.current = null
        setCoolingDown(false)
      }, REMINDER_COOLDOWN_MS)
    } catch (error) {
      showToast(toApiMessage(error), "danger")
    } finally {
      setPendingId(null)
    }
  }

  return { remind, pendingId, coolingDown }
}
